import BlDialogMv from './BlDialogMv.vue'

BlDialogMv.install = function(Vue) {
  Vue.component(BlDialogMv.name, BlDialogMv)
}

export default BlDialogMv
